export const ACTIVE_CONTEXT_CHANGED = 'contextNav/ACTIVE_CONTEXT_CHANGED';
export const RESET_ACTIVE_INDEX = 'contextNav/RESET_ACTIVE_INDEX';
export const RESET_CONTEXT_NAV = 'contextNav/RESET_CONTEXT_NAV';
export const UPDATE_ACTIVE_INDEX = 'contextNav/UPDATE_ACTIVE_INDEX';
